export function detectPlatformOs(nav = typeof navigator !== 'undefined' ? navigator : undefined) {
  if (!nav?.userAgent) return 'unknown';

  const ua = nav.userAgent;

  if (/android/i.test(ua)) return 'android';
  if (/iphone|ipad|ipod/i.test(ua)) return 'ios';
  // iPadOS 13+ reports a desktop Safari UA ("Macintosh") but is touch-capable.
  if (/macintosh/i.test(ua) && nav.maxTouchPoints > 1) return 'ios';

  return 'web';
}
